var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyGroups(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 104,
    viewBox: "0 0 146 104",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125.247 86.9959H16.7526C23.6314 71.6724 45.2744 60.4874 70.9999 60.4874C96.6696 60.4315 118.369 71.6165 125.247 86.9959Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M132.899 86.9958H144.308",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.86688 86.9958H127.195",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1489 94.4338H131.389",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3382 94.4338H30.0532",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M120.372 23.5208C105.888 36.4954 97.4988 52.0985 96.604 71.3927",
    stroke: "#D6DCE8",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8536 32.2507C29.1027 41.9392 35.7379 53.7246 36.7077 68.4389",
    stroke: "#D6DCE8",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M121.211 23.5766C121.211 23.5766 117.073 18.9349 111.872 14.4049L112.654 12.5035L110.138 12.9509C108.404 11.4968 106.559 10.0987 104.713 8.98019C108.292 6.85504 111.368 7.07874 114.164 8.86834C119.254 12.0001 120.596 18.096 121.211 23.5766Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2141 32.3058C17.2141 32.3058 20.3041 28.7011 24.2068 25.166L23.5809 23.7263L25.5085 24.0304C26.8102 22.8947 28.1982 21.8001 29.5903 20.9189C26.8266 19.3499 24.4821 19.5664 22.3742 20.974C18.5361 23.4401 17.6022 28.1131 17.2141 32.3058Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M119.477 22.6819C119.477 22.6819 114.332 21.3397 108.516 20.5568L108.181 18.8231L106.615 20.3331C104.657 20.1094 102.7 19.9975 100.91 20.0534C102.476 16.8657 104.713 15.5794 107.621 15.5235C112.599 15.3557 116.457 19.1027 119.477 22.6819Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5242 31.5971C18.5242 31.5971 22.4316 30.4961 26.8596 29.8121L27.0899 28.4837L28.3077 29.613C29.7984 29.4132 31.2909 29.2987 32.6577 29.3148C31.4151 26.9049 29.6884 25.9563 27.4678 25.9568C23.666 25.9027 20.7762 28.8202 18.5242 31.5971Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M120.596 24.5834C120.596 24.5834 120.484 17.9842 119.421 10.8258L121.379 9.87505L119.086 8.53284C118.694 6.18399 118.135 3.77921 117.464 1.65405C121.77 2.437 124.063 4.67401 125.126 8.08544C126.915 13.9576 123.784 19.7738 120.596 24.5834Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6987 33.0651C17.6987 33.0651 17.686 28.0262 18.3907 22.5463L16.8825 21.8496L18.6127 20.791C18.8766 18.9923 19.2678 17.1484 19.7485 15.5162C16.4731 16.1779 14.7561 17.9195 13.9957 20.5393C12.717 25.0482 15.194 29.4413 17.6987 33.0651Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M119.533 24.08C119.533 24.08 123.56 28.8336 127.363 34.5939L129.32 34.0346L128.537 36.4394C129.712 38.3968 130.83 40.4101 131.725 42.3675C134.298 39.1238 134.521 36.0479 133.123 32.972C130.718 27.6592 124.846 25.4781 119.533 24.08Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5023 32.6652C18.5023 32.6652 15.4994 36.3535 12.6822 40.807L11.1798 40.4092L11.8131 42.2332C10.9458 43.7447 10.1219 45.2981 9.468 46.8055C7.45612 44.3678 7.23965 42.0233 8.26115 39.6546C10.0178 35.5635 14.4677 33.8113 18.5023 32.6652Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M119.701 23.409C119.701 23.409 126.188 24.4156 133.179 26.4849L134.409 24.6952L135.416 27.156C137.709 27.883 140.002 28.7219 142.015 29.7285C141.847 25.3664 139.946 22.7379 136.702 21.2279C131.11 18.5435 124.902 20.8364 119.701 23.409Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3642 32.1554C18.3642 32.1554 13.4273 33.0202 8.12195 34.7036L7.1562 33.3558L6.42438 35.2491C4.68495 35.8381 2.94719 36.5125 1.42536 37.3108C1.48859 33.9786 2.90094 31.944 5.35444 30.7432C9.5834 28.611 14.3559 30.269 18.3642 32.1554Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M121.721 21.6161C122.693 20.6446 122.693 19.0693 121.721 18.0977C120.75 17.1261 119.175 17.1261 118.203 18.0977C117.231 19.0693 117.231 20.6446 118.203 21.6161C119.175 22.5877 120.75 22.5877 121.721 21.6161Z",
    fill: "#D6DCE8",
    stroke: "#AAB2C5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7954 30.8169C16.0393 30.0897 16.0159 28.8873 16.7431 28.1312C17.4703 27.3752 18.6727 27.3518 19.4288 28.0789C20.1848 28.8061 20.2082 30.0085 19.481 30.7646C18.7539 31.5207 17.5515 31.5441 16.7954 30.8169Z",
    fill: "#D6DCE8",
    stroke: "#AAB2C5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M125.249 25.6791C126.619 24.31 126.619 22.0904 125.249 20.7213C123.88 19.3523 121.661 19.3523 120.292 20.7213C118.923 22.0904 118.923 24.31 120.292 25.6791C121.661 27.0481 123.88 27.0481 125.249 25.6791Z",
    fill: "#D6DCE8",
    stroke: "#AAB2C5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1628 33.9707C13.0975 32.946 13.0645 31.2517 14.0891 30.1864C15.1138 29.121 16.8081 29.088 17.8735 30.1127C18.9388 31.1374 18.9718 32.8317 17.9472 33.897C16.9225 34.9624 15.2282 34.9954 14.1628 33.9707Z",
    fill: "#D6DCE8",
    stroke: "#AAB2C5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M120.219 25.2891C121.102 24.4058 121.102 22.9738 120.219 22.0905C119.335 21.2073 117.903 21.2073 117.02 22.0905C116.137 22.9738 116.137 24.4058 117.02 25.2891C117.903 26.1724 119.335 26.1724 120.219 25.2891Z",
    fill: "#D6DCE8",
    stroke: "#AAB2C5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9971 33.5982C17.3098 32.9371 17.2885 31.844 17.9496 31.1567C18.6107 30.4694 19.7038 30.4481 20.3911 31.1092C21.0784 31.7702 21.0997 32.8633 20.4386 33.5507C19.7776 34.238 18.6845 34.2593 17.9971 33.5982Z",
    fill: "#D6DCE8",
    stroke: "#AAB2C5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M25.0199 81.7388C26.8654 81.3473 28.8228 81.9066 30.2209 83.1369",
    stroke: "#D6DCE8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M44.7615 75.6431C46.4952 74.972 48.2288 74.4127 50.0744 73.9653C51.1929 73.6857 52.3673 73.5179 53.4858 73.7416C54.6043 73.9653 55.6669 74.8042 55.8906 75.9227",
    stroke: "#D6DCE8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M69.9836 78.0477C72.2766 75.2515 76.415 74.1889 79.7705 75.4752C80.4976 75.7548 81.1687 76.1463 81.9516 76.0903C82.7905 76.0344 83.4616 75.4752 84.0768 74.9159C84.6919 74.3567 85.2512 73.7415 86.0341 73.4059C86.8171 73.1263 87.8237 73.2941 88.2152 74.0211",
    stroke: "#D6DCE8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M92.2977 81.0678C95.1499 79.1104 98.8969 78.4952 102.252 79.3341",
    stroke: "#D6DCE8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M40.0637 69.5472C40.2315 68.6524 41.2941 68.1491 42.2448 68.2609C43.1955 68.3169 44.0344 68.7643 44.9851 68.932C46.2155 69.1557 47.5018 68.8202 48.5084 68.0372",
    stroke: "#D6DCE8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M27.8721 77.9919C29.7176 78.1038 31.6191 77.4886 33.129 76.426",
    stroke: "#D6DCE8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M75.688 68.8201C77.5335 68.5404 79.435 68.8201 81.0568 69.6589",
    stroke: "#D6DCE8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M66.4603 66.9747C74.5217 66.9747 81.0568 65.962 81.0568 64.7129C81.0568 63.4637 74.5217 62.451 66.4603 62.451C58.3989 62.451 51.8639 63.4637 51.8639 64.7129C51.8639 65.962 58.3989 66.9747 66.4603 66.9747Z",
    fill: "#D5DAE8"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7046 102.045H102.503",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6001 44.2176C85.6001 49.0176 83.8894 53.3836 81.0298 56.8049C77.4298 61.1199 72.017 63.8518 65.9404 63.8518C60.119 63.8518 54.9105 61.3241 51.3104 57.3156C48.221 53.8432 46.3317 49.2474 46.3317 44.2176C46.3317 33.3664 55.1147 24.5834 65.9659 24.5834C76.817 24.5834 85.6001 33.3664 85.6001 44.2176Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0554 56.805C77.4554 61.1199 72.0426 63.8519 65.9659 63.8519C60.1446 63.8519 54.936 61.3242 51.336 57.3156C51.9488 56.8305 52.7147 56.3965 53.6594 56.0135L54.3743 55.7326C55.7275 55.1965 57.4892 54.5326 59.8637 53.5369C60.3999 53.3071 60.834 52.8986 61.0637 52.3624C61.1914 52.0815 61.268 51.7496 61.268 51.4177V47.0006C61.1914 46.8985 61.1148 46.8219 61.0637 46.7198C60.6808 46.1581 60.4254 45.4943 60.3488 44.7794L59.9659 44.6006C58.8169 44.8815 58.8935 43.6559 58.6127 41.307C58.485 40.3368 58.6382 40.1325 59.0722 39.9793L59.4297 39.4942C57.2339 34.5154 58.3318 31.4005 60.502 30.3026C59.7871 28.7196 59.7361 28.1579 59.7361 28.1579C59.7361 28.1579 64.3574 28.9239 65.9659 28.6175C67.983 28.209 71.0979 28.6941 72.2468 31.375C74.1617 32.1409 74.9277 33.341 75.0809 34.6686C75.3617 36.7623 74.1617 39.0602 73.9319 39.9538C73.9575 40.0048 73.983 40.0304 73.983 40.0559C74.2894 40.2091 74.3915 40.4644 74.2894 41.307C74.0085 43.5283 74.0851 44.907 72.9362 44.6006L71.9149 46.3879C71.8638 46.5921 71.8638 46.6687 71.8383 46.8219C71.7872 47.1538 71.8128 47.8177 71.8128 51.4688C71.8128 51.9028 71.9404 52.3113 72.1702 52.6943C72.4255 53.0773 72.783 53.4092 73.2426 53.5879C73.2426 53.5879 73.2681 53.5879 73.2936 53.6135C75.9235 54.7114 77.8128 55.4263 79.1916 55.9624C79.9065 56.1922 80.5192 56.4986 81.0554 56.805Z",
    fill: "white",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M73.983 39.9282C74.0852 39.3665 73.8298 38.6771 73.6256 38.192C73.6001 38.1154 73.549 38.0388 73.5235 37.9367C72.6298 36.1495 70.6639 35.4346 68.7745 35.3324C63.9489 35.0771 63.5149 35.9963 62.0085 34.6175C62.468 35.3324 62.5191 36.4303 61.8042 37.809C61.2936 38.7793 60.3233 39.2133 59.4808 39.4942C57.285 34.5154 58.3829 31.4005 60.5531 30.3026C59.8382 28.7196 59.7872 28.1579 59.7872 28.1579C59.7872 28.1579 64.4085 28.9239 65.9915 28.6175C68.0085 28.209 71.1234 28.6941 72.2724 31.3749C74.1873 32.1409 74.9277 33.3409 75.1064 34.6686C75.3873 36.7367 74.2128 39.0091 73.983 39.9282Z",
    fill: "#989FB0"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M61.268 47.0006C61.1914 46.8984 61.1148 46.8218 61.0638 46.7197V46.4644C61.2936 46.8729 61.6 47.2559 61.9829 47.5623L65.4808 49.9878C66.2979 50.6772 67.4723 50.7027 68.3149 50.0389L71.583 47.1027C71.6852 47.0006 71.8128 46.8984 71.9149 46.7963",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyGroups);
export default __webpack_public_path__ + "static/media/empty-groups.21a21d15e793f982a1521e27da95030e.svg";
export { ForwardRef as ReactComponent };